import logger from "@next/core-logger"
import {axiosInstance as axios} from "../../utils/axios"
import GeolocationApiConfig from "../../config/api/countryRedirect"
import {GeolocationModel} from "../../models/geolocation"
import {CONTENT_TYPE, MULTIPART_FORM_DATA} from "../../config/constants"

export const getGeolocation = async (baseUrl: string, ipAddress: string | null): Promise<GeolocationModel | null> => {
    try {
        const getGeolocationDataApi = GeolocationApiConfig("getGeolocationData")
        const response = await axios({
            method: getGeolocationDataApi.method,
            url: `${baseUrl}${getGeolocationDataApi.localEndpoint(ipAddress)}`,
        })
        return response.data
    } catch (ex) {
        logger.error(ex)
        throw ex
    }
}

interface UpdateSessionData {
    Version: number
    PopupDisplayed: boolean
    ShowPopup: boolean
    ISOCode: null | string
    CountryName: null | string
    RedirectUrl: null | string
    Attempt: number
}

export const updateSession = async (baseUrl: string, data: UpdateSessionData): Promise<void> => {
    try {
        const getGeolocationDataApi = GeolocationApiConfig("sessionUpdate")
        await axios({
            method: getGeolocationDataApi.method,
            url: `${baseUrl}${getGeolocationDataApi.localEndpoint()}`,
            data,
        })
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        throw ex
    }
}

export const confirmChannelChange = async (baseUrl: string, data: string | undefined): Promise<void> => {
    try {
        const getGeolocationDataApi = GeolocationApiConfig("confirmChannelChange")
        const sendData = {ChannelRedirect_url: data}
        await axios({
            method: getGeolocationDataApi.method,
            url: `${baseUrl}${getGeolocationDataApi.localEndpoint()}`,
            data: sendData,
            headers: {[CONTENT_TYPE]: MULTIPART_FORM_DATA},
        })
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        throw ex
    }
}

export default getGeolocation
